import { render } from "./FooterMenuIcon.vue?vue&type=template&id=5872466f&scoped=true"
import script from "./FooterMenuIcon.vue?vue&type=script&lang=js"
export * from "./FooterMenuIcon.vue?vue&type=script&lang=js"

import "./FooterMenuIcon.vue?vue&type=style&index=0&id=5872466f&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5872466f"]])

export default __exports__